import { Controller } from "@hotwired/stimulus"

// Drives interactive bits of the onboarding flow:
//
//   step 2 — color swatches + initial-mark live preview
//   step 3 — commission-type cards (radio + label/prefix swap)
//
// data-controller="onboarding"
// step 2:
//   <input ... data-onboarding-target="swatchInput" data-action="change->onboarding#swatch">
//   <div  data-onboarding-target="initialMark">
// step 3:
//   <input type="radio" data-onboarding-target="choiceInput" data-action="change->onboarding#choice">
//   <span data-onboarding-target="affix">
//   <span data-onboarding-target="affixLabel">
export default class extends Controller {
  static targets = ["swatchInput", "initialMark", "choiceInput", "affix", "affixLabel"]

  swatch(event) {
    const color = event.currentTarget.value
    if (this.hasInitialMarkTarget) {
      this.initialMarkTarget.style.setProperty("--c", color)
    }
  }

  choice(event) {
    const id = event.currentTarget.value
    if (this.hasChoiceInputTarget) {
      this.choiceInputTargets.forEach((input) => {
        const card = input.closest(".choice-card")
        if (card) card.classList.toggle("is-selected", input.checked)
      })
    }
    const isFlat = id === "flat"
    if (this.hasAffixTarget)      this.affixTarget.textContent      = isFlat ? "$" : "%"
    if (this.hasAffixLabelTarget) this.affixLabelTarget.textContent = isFlat ? "Amount per signup (USD)" : "Percentage"
  }
}
